import React, { useRef } from 'react'
import type { DialogProps } from '../components/Dialog'
import Dialog, { DialogTitle, DialogActions, DialogContent } from '../components/Dialog'
import Button from '../components/Button'
import Grid from '../components/Grid'
import { makeStyles } from '@material-ui/core'
import Typography from '../components/Typography'
import type { EditorProps } from '../components/Editor'
import { Editor } from '../components/Editor'

export interface EditorDialogProps extends DialogProps {
  inputProps?: Omit<EditorProps, 'onChange' | 'onBlur' | 'value' | 'content'>
  title?: React.ReactNode
  message?: React.ReactNode
  yesLabel?: React.ReactNode
  noLabel?: React.ReactNode
  value?: string
  onConfirm?: (event: React.MouseEvent<HTMLElement>, value: string) => void
  onCancel?: (event: React.MouseEvent<HTMLElement>) => void
}

const useStyles = makeStyles(() => ({
  content: {
    minHeight: 200
  }
}))
function EditorDialog({
  onCancel,
  onConfirm,
  title,
  message,
  yesLabel,
  noLabel,
  inputProps,
  ...otherProps
}: EditorDialogProps) {
  const classes = useStyles(otherProps)

  const editorRef = useRef(null)

  async function handleConfirm(ev: any) {
    const value = editorRef.current?.getHTML()
    onConfirm(ev, value)
  }

  return (
    <Dialog onClose={onCancel} {...otherProps}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent className={classes.content}>
        <Grid container spacing={2}>
          {message && (
            <Grid item xs={12}>
              <Typography variant="body1" component="div" align="center">
                {message}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <Editor fullWidth={true} content={otherProps.value} ref={editorRef} {...inputProps} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        leftButton={
          <Button onClick={onCancel} variant="textNoPadding">
            {noLabel}
          </Button>
        }
      >
        <Button onClick={handleConfirm} variant={'contained'}>
          {yesLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

EditorDialog.defaultProps = {
  title: 'Edit',
  yesLabel: 'Ok',
  noLabel: 'Cancel'
}
export default EditorDialog
